import React from "react";
import MuiMobileStepper from "@mui/material/MobileStepper";

function MobileStepper(props) {
  return <MuiMobileStepper {...props} />;
}

export default MobileStepper;
